import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card } from 'antd';
import moment from 'moment';
import { listSummaries } from '../../store/actions/summary';
import { usePolling } from '../../hooks/usePolling';

const CPTCodes = ({ encounterStatus, allowed }) => {
  const { cptCodesSummary, cptCodesUpdatedAt } = useSelector(
    (state) => state.summaryState
  );
  const { encounterDetails } = useSelector((state) => state?.encounterState);
  const dispatch = useDispatch();

  const calculateRefreshInterval = useCallback(() => {
    const isGenerating = encounterDetails?.cpt_status === 'inprogress';
    return isGenerating ? 10000 : 60000;
  }, [encounterDetails?.cpt_status]);

  const fetchCptCodes = useCallback(() => {
    if (encounterDetails?.encounter_id) {
      dispatch(listSummaries(encounterDetails.encounter_id, 'in-visit', 'cpt'));
    }
  }, [dispatch, encounterDetails?.encounter_id]);

  usePolling(
    {
      pollingFunction: fetchCptCodes,
      calculateInterval: calculateRefreshInterval,
    },
    [encounterDetails?.cpt_status]
  );

  if (!allowed) {
    return (
      <div className="text-gray-400 p-4">
        CPT coding feature is not enabled for this account.
      </div>
    );
  }

  if (encounterStatus != 'completed') {
    return (
      <div className="text-gray-400 p-4">
        CPT codes will appear shortly after the note is generated.
      </div>
    );
  }

  return (
    <div className="p-4">
      {cptCodesUpdatedAt && encounterDetails?.cpt_status === 'ready' && (
        <span className="text-gray-400 text-xs flex justify-center mb-2">
          Last updated {moment(cptCodesUpdatedAt).fromNow()}
        </span>
      )}
      {cptCodesSummary?.codes?.map((summary, index) => {
        return (
          <Card
            key={index}
            title={
              <span className="text-lg" style={{ color: 'rgb(0, 208, 145)' }}>
                {summary.name}
              </span>
            }
            className="mb-4 "
          >
            <div className="font-medium" style={{ color: 'black' }}>
              Description
            </div>
            <p
              className="text-gray-600 text-xs"
              style={{ marginBottom: '10px' }}
            >
              {summary.description}
            </p>
          </Card>
        );
      })}
      {encounterDetails?.cpt_status === 'ready' &&
        !cptCodesSummary?.codes?.length && (
          <div className="text-gray-400">
            No CPT codes found for this encounter.
          </div>
        )}
      {encounterDetails?.cpt_status !== 'ready' && (
        <div className="text-gray-400">Extracting CPT codes...</div>
      )}
    </div>
  );
};

export default React.memo(CPTCodes);
